import {NgModule}      from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule}   from '@angular/forms';

import {AppComponent}  from './app.component';
import { SignUp } from './forms/signup.component';
import { Update } from './forms/update.component';
import { Success } from './messages/success.component';
import { Fail } from './messages/fail.component';

import {AppRoutingModule}  from './app-routing.module';

import {BooleanPipe} from './pipes/boolean.pipe';
import {GoDatePipe} from './pipes/godate.pipe';
import {VersionPipe} from './pipes/version.pipe';
import {HumanIntervalPipe} from './pipes/human-interval.pipe';
import {CommsTypePipe} from './pipes/comms-type';
import {HeatingStatePipe} from './pipes/heating-state';
import {UnixDatePipe} from './pipes/unixdate.pipe';

import {ApiService} from './services/api.service';

import {HttpClientModule} from '@angular/common/http';
import {MatButtonModule, MatCheckboxModule} from '@angular/material';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  imports:      [
    BrowserModule,  // This should always be first
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  declarations: [
    AppComponent,
    SignUp,
    Update,
    Success,
    Fail,
    BooleanPipe,
    GoDatePipe,
    VersionPipe,
    HumanIntervalPipe,
    CommsTypePipe,
    HeatingStatePipe,
    UnixDatePipe,
  ],
  providers:    [
    ApiService,
    ],
  bootstrap:    [ AppComponent ],
})


export class AppModule {
}
